// components/data-quality/OverallQualityMetrics.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationTriangle,
  faChartLine,
  faCalendarDay,
  faListAlt,
} from "@fortawesome/free-solid-svg-icons";

const OverallQualityMetrics = ({ metrics }) => {
  const getQualityScoreClass = (score) => {
    if (score >= 90) return "text-green-600";
    if (score >= 70) return "text-blue-600";
    if (score >= 50) return "text-yellow-600";
    if (score >= 30) return "text-orange-600";
    return "text-red-600";
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {/* Average Quality Score */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="flex items-start">
          <div className="bg-blue-100 p-3 rounded-full">
            <FontAwesomeIcon icon={faChartLine} className="text-blue-600" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">
              Average Quality
            </h3>
            <p
              className={`text-2xl font-bold ${getQualityScoreClass(
                metrics.averageQualityScore
              )}`}
            >
              {metrics.averageQualityScore.toFixed(1)}%
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            Based on {metrics.totalBookings} bookings
          </div>
        </div>
      </div>

      {/* Perfect Quality Count */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="flex items-start">
          <div className="bg-green-100 p-3 rounded-full">
            <FontAwesomeIcon icon={faCheckCircle} className="text-green-600" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">
              Perfect Quality
            </h3>
            <p className="text-2xl font-bold text-green-600">
              {metrics.perfectQualityCount}
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            {(
              (metrics.perfectQualityCount / metrics.totalBookings) *
              100
            ).toFixed(1)}
            % of total
          </div>
        </div>
      </div>

      {/* Abandoned Count */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="flex items-start">
          <div className="bg-red-100 p-3 rounded-full">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="text-red-600"
            />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Abandoned</h3>
            <p className="text-2xl font-bold text-red-600">
              {metrics.abandonedCount}
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            {((metrics.abandonedCount / metrics.totalBookings) * 100).toFixed(
              1
            )}
            % of total
          </div>
        </div>
      </div>

      {/* Status Progression */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="flex items-start">
          <div className="bg-purple-100 p-3 rounded-full">
            <FontAwesomeIcon icon={faListAlt} className="text-purple-600" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Valid Status</h3>
            <p className="text-2xl font-bold text-purple-600">
              {metrics.statusProgression.validProgression}
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            {(
              (metrics.statusProgression.validProgression /
                metrics.totalBookings) *
              100
            ).toFixed(1)}
            % have valid progression
          </div>
        </div>
      </div>

      {/* Date Quality */}
      <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
        <div className="flex items-start">
          <div className="bg-yellow-100 p-3 rounded-full">
            <FontAwesomeIcon icon={faCalendarDay} className="text-yellow-600" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Valid Dates</h3>
            <p className="text-2xl font-bold text-yellow-600">
              {metrics.dateQuality.validDates}
            </p>
          </div>
        </div>
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            {metrics.dateQuality.bookingsWithGaps} bookings have date gaps &gt;7
            days
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallQualityMetrics;
